<template>
  <v-col>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="localtranslation.name"
          :rules="rules.requiredTextLine65"
          :counter="65"
          :label="`${$t('APP_CONTENT.NAME_IN_THE_APP')}` + requiredStr"
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="localtranslation.url"
          :rules="rules.requiredTextLine"
          :label="`${$t('APP_CONTENT.WEB_URL')} *`"
          outlined
        />
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import { cloneDeep } from 'lodash';
import {
  requiredTextLine,
  requiredTextLine65
} from '@/modules/_global/variables/rules.js';

export default {
  name: 'AppContentIframeForm',

  model: {
    prop: 'translation'
  },

  props: {
    translation: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    requiredStr: '',
    valid: true,
    localtranslation: {},
    rules: {
      requiredTextLine,
      requiredTextLine65
    }
  }),
  watch: {
    localtranslation: {
      deep: true,
      handler: 'setTranslation'
    },
    translation: {
      deep: true,
      handler() {
        if (
          JSON.stringify(this.translation) ===
          JSON.stringify(this.localtranslation)
        ) {
          return;
        }
        this.setData();
      }
    }
  },
  created() {
    this.setData();
    this.setRequired();
  },

  methods: {
    setData() {
      this.localtranslation = cloneDeep(this.translation);
    },
    setTranslation() {
      this.$emit('input', Object.assign({}, this.localtranslation));
    },
    setRequired() {
      this.requiredStr = ' *';
    }
  }
};
</script>
